import { apiBaseURL } from '../../constants';
import apiConfig from '../../config/apiConfig';

// Thin pass-through thunks: they return the axios promise untouched so the
// calling component keeps its own loading / error handling.
const NOTIFICATIONS = apiBaseURL.NOTIFICATIONS

export const fetchNotificationInboxRaw = () => () => apiConfig.get(`${NOTIFICATIONS}?perPage=15`)
export const markNotificationRead = (notificationId) => () => apiConfig.post(`${NOTIFICATIONS}/${notificationId}/read`)
export const acknowledgeNotification = (notificationId) => () => apiConfig.post(`${NOTIFICATIONS}/${notificationId}/acknowledge`)
export const markAllNotificationsRead = () => () => apiConfig.post(`${NOTIFICATIONS}/read-all`)

export const fetchNotificationPreferencesRaw = () => () => apiConfig.get(`${NOTIFICATIONS}/preferences`)
export const updateNotificationPreferences = (payload) => () => apiConfig.put(`${NOTIFICATIONS}/preferences`, payload)
export const fetchNotificationSubscriptionsRaw = () => () => apiConfig.get(`${NOTIFICATIONS}/subscriptions`)
export const fetchNotificationDeliveriesRaw = () => () => apiConfig.get(`${NOTIFICATIONS}/deliveries?perPage=30`)
export const createNotificationSubscription = (payload) => () => apiConfig.post(`${NOTIFICATIONS}/subscriptions`, payload)
export const updateNotificationSubscription = (subscriptionId, payload) => () => apiConfig.put(`${NOTIFICATIONS}/subscriptions/${subscriptionId}`, payload)
export const deleteNotificationSubscription = (subscriptionId) => () => apiConfig.delete(`${NOTIFICATIONS}/subscriptions/${subscriptionId}`)
export const testNotificationSubscription = (subscriptionId) => () => apiConfig.post(`${NOTIFICATIONS}/subscriptions/${subscriptionId}/test`)

export const fetchNotificationFollowsRaw = () => () => apiConfig.get(`${NOTIFICATIONS}/follows`)
export const deleteNotificationFollow = (followId) => () => apiConfig.delete(`${NOTIFICATIONS}/follows/${followId}`)

export const fetchNotificationSuppressionsRaw = () => () => apiConfig.get(`${NOTIFICATIONS}/suppressions`)
export const releaseNotificationSuppression = (suppressionId, payload) => () => apiConfig.post(`${NOTIFICATIONS}/suppressions/${suppressionId}/release`, payload)
